import React from "react";
import "./anchor.scss";
import "../../../styles/fontSizes.scss";

// flechas del tipo ^ = type en 1 , v = type en 0
const Anchor = ({ children, textSize, className, color, onClick }) => {
  return (
    <>
      <a
        style={{ color: color }}
        onClick={onClick}
        href={""}
        className={`anchor__a-tag ${onClick && " anchor__a--active"} ${
          className ? className : ""
        } font-size--${textSize ? textSize : 1}`}
      >{`-${children}-`}</a>
    </>
  );
};

export default Anchor;
